import ADMIN_PORTAL_LOGO from '@/assets/images/apilogy-logo.png';
import UNAUTH_IMAGE from '@/assets/images/401.png';

import { FaArrowCircleLeft } from 'react-icons/fa';
import MainHeader from '@/components/MainHeader';
import Button from '@/components/Button';
import { axiosClient } from '@/services/utilities';
import { useNavigate } from 'react-router-dom';
const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate('/');
  };

  const onLoginHandle = async () => {
    try {
      const { data } = await axiosClient.get('/auth/url');
      window.open(data, '_self');
    } catch (error) {
      console.error('Failed to fetch authentication URL', error);
    }
  };

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      {/* Header Bar */}
      <MainHeader logo={ADMIN_PORTAL_LOGO} onLogin={onLoginHandle} />

      <div className="flex flex-col items-center justify-center px-4 mt-20">
        {/* Unauthorized Image */}
        <img
          src={UNAUTH_IMAGE}
          alt="Unauthorized"
          className="w-full max-w-md mb-8"
        />

        {/* Unauthorized Content */}
        <h1 className="mb-4 text-2xl font-bold text-center text-black md:text-4xl">
          Unauthorized Access to Admin Portal
        </h1>
        <p className="mb-6 text-sm text-center text-black md:text-base opacity-60">
          You don’t have permission to access this page. Please contact the
          system administrator for assistance.
        </p>

        <div className="flex justify-center w-full md:w-auto">
          <Button
            onClick={handleGoBack}
            iconLeft={<FaArrowCircleLeft size={18} />}
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
